import { AfterViewInit, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppService } from '../../app.service';

@Component({
    selector: 'app-footer-component',
    templateUrl: './footer-component.component.html',
    styleUrls: ['./footer-component.component.scss'],
    standalone: false
})
export class FooterComponentComponent implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);

  year = new Date().getFullYear();
  isAcura: boolean = false;
  constructor(private appService: AppService, private router: Router) { }


  ngOnInit(): void {

  }
  onLinkClick() {
    this.router.navigate(['/'])
  }

  ngAfterViewInit(): void {
    this.appService.checkIsDataAvailable().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      setTimeout(() => {
        if (res) {
          this.setIsAcuraLocally()
        } else {
          this.getVehicleDetails()
        }
      }, 1);
    });
  }
  setIsAcuraLocally() {
    let vehicleData = this.appService.getVehicleData()
    if (vehicleData) {
      if (vehicleData.make == "Acura") {
        this.isAcura = true
      }
    }
  }
  getVehicleDetails() {
    this.appService.MyVehicle().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      if (res && res.status == "SUCCESS") {
        let vehicleInfo = res.vehicleInfo
        if (vehicleInfo && vehicleInfo.length > 0) {
          let vehicleMake = vehicleInfo[0].DivisionName
          if (vehicleMake == 'Honda') {
            this.isAcura = false
          } else {
            this.isAcura = true
          }
        }
      }
    })
  }

}
